<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b
              ><u>
                تقرير مختصر فرع {{ select_branch.name }} بتاريخ من
                {{ date_from }} الي تاريخ {{ date_to }}</u
              >
            </b>
          </p>
        </v-flex>
        <!-- <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_item"
                    :items="items"
                    item-text="name"
                    item-value="id"
                    label="أختر الصنف"
                    persistent-hint
                    return-object
                    single-line
                   
                ></v-select>
                  </v-flex>  -->
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_branch"
            :items="branches"
            item-text="name"
            item-value="id"
            label=" أختر الفرع "
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_to"
            v-model="modal_to"
            :return-value.sync="date_to"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_to"
                label="تاريخ الي"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_to" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_to = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md2>
          <v-btn @click="BranchSalesReport">تأكيد</v-btn>
        </v-flex>
        <br />
      </v-layout>

      <v-data-table :headers="headers1" :items="myitems" class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.all_of_total }}</td>
          <td>{{ props.item.all_of_total2 }}</td>
          <td>{{ props.item.all_of_total3 }}</td>
          <td>{{ props.item.all_of_total4 }}</td>
          <td>{{ props.item.all_of_total5 }}</td>
          <td>{{ props.item.all_of_total6 }}</td>
          <td>{{ props.item.all_of_total7 }}</td>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import {
  items,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  branches,
  khazina,
  khazna_fatworas,
  BranchSalesReport
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [11400, 11800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers1: [
      {
        text: "مجموع المبيعات",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مجموع المرتجعات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مجموع المشتريات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مجموع مرتجع المشتريات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مجموع المصروفات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مجموع السدادات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "مجموع الخصومات ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_item: { id: "" },
    select_branch: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    items: [],
    fatworas: [],
    fatworas2: [],
    fatworas3: [],
    fatworas4: [],
    fatworas5: [],
    fatworas6: [],
    fatworas7: [],
    branches: [],
    myitems: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail1: {},
    item_detail12: {},
    item_detail2: {},
    item_detail22: {},
    item_detail3: {},
    item_detail32: {},
    item_detail4: {},
    item_detail42: {},
    item_detail5: {},
    item_detail52: {},
    item_detail6: {},
    item_detail62: {},
    detail_dialog1: false,
    detail_dialog12: false,
    detail_dialog2: false,
    detail_dialog22: false,
    detail_dialog3: false,
    detail_dialog32: false,
    detail_dialog4: false,
    detail_dialog42: false,
    detail_dialog5: false,
    detail_dialog52: false,
    detail_dialog6: false,
    detail_dialog62: false,
    all_of_total: 0,
    count_of_count: 0,
    all_of_total2: 0,
    count_of_count2: 0,
    all_of_total3: 0,
    count_of_count3: 0,
    all_of_total4: 0,
    count_of_count4: 0,
    all_of_total5: 0,
    count_of_count5: 0,
    all_of_total6: 0,
    count_of_count6: 0,
    all_of_total7: 0,
    count_of_count7: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branches = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_branch.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem1(order) {
      this.item_detail1 = order;
    },
    detailItem12(order) {
      this.item_detail12 = order;
    },
    detailItem2(order) {
      this.item_detail2 = order;
    },
    detailItem22(order) {
      this.item_detail22 = order;
    },
    detailItem3(order) {
      this.item_detail3 = order;
    },
    detailItem32(order) {
      this.item_detail32 = order;
    },
    detailItem4(order) {
      this.item_detail4 = order;
    },
    detailItem42(order) {
      this.item_detail42 = order;
    },
    detailItem5(order) {
      this.item_detail5 = order;
    },
    detailItem52(order) {
      this.item_detail52 = order;
    },
    detailItem6(order) {
      this.item_detail6 = order;
    },
    detailItem62(order) {
      this.item_detail62 = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    BranchSalesReport() {
      var frmData = new FormData();
      frmData.append("branch_id", this.select_branch.id);
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      BranchSalesReport(frmData).then(response => {
        response.data.myarr.length > 0
          ? (this.fatworas = response.data.myarr)
          : (this.fatworas = []);
        response.data.myarr2.length > 0
          ? (this.fatworas2 = response.data.myarr2)
          : (this.fatworas2 = []);
        response.data.myarr3.length > 0
          ? (this.fatworas3 = response.data.myarr3)
          : (this.fatworas3 = []);
        response.data.myarr4.length > 0
          ? (this.fatworas4 = response.data.myarr4)
          : (this.fatworas4 = []);
        response.data.myarr5.length > 0
          ? (this.fatworas5 = response.data.myarr5)
          : (this.fatworas5 = []);
        response.data.myarr6.length > 0
          ? (this.fatworas6 = response.data.myarr6)
          : (this.fatworas6 = []);
        response.data.myarr7.length > 0
          ? (this.fatworas7 = response.data.myarr7)
          : (this.fatworas7 = []);
        this.all_of_total = response.data.all_of_total;
        this.count_of_count = response.data.count_of_count;
        this.all_of_total2 = response.data.all_of_total2;
        this.count_of_count2 = response.data.count_of_count2;
        this.all_of_total3 = response.data.all_of_total3;
        this.count_of_count3 = response.data.count_of_count3;
        this.all_of_total4 = response.data.all_of_total4;
        this.count_of_count4 = response.data.count_of_count4;
        this.all_of_total5 = response.data.all_of_total5;
        this.count_of_count5 = response.data.count_of_count5;
        this.all_of_total6 = response.data.all_of_total6;
        this.count_of_count6 = response.data.count_of_count6;
        this.all_of_total7 = response.data.all_of_total7;
        this.count_of_count7 = response.data.count_of_count7;
        this.myitems = [
          {
            all_of_total: this.all_of_total,
            all_of_total2: this.all_of_total2,
            all_of_total3: this.all_of_total3,
            all_of_total4: this.all_of_total4,
            all_of_total5: this.all_of_total5,
            all_of_total6: this.all_of_total6,
            all_of_total7: this.all_of_total7
          }
        ];
      });
    }
  }
};
</script>

<style scoped>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-icon.ml-4.v-icon--link.material-icons.theme--dark {
  font-size: 25px !important;
  z-index: 99999999;
}
</style>
